import React from 'react';
import { Card } from 'react-bootstrap';

function CaseCard({ numberCase, caseType, statusColor, onCardClick }) {


  const STAUSCOLOR = {
    'red': "status-red",
    'yellow': "status-yellow",
    'blue': "status-blue",
    'green': "status-green",
    'gray': "status-gray",
    'lightGray': 'status-light-gray',
  };

  let bgColorClass = STAUSCOLOR[statusColor];




  return (
    <div className='mt-4 rounded-border case-card-container custom-shadow' onClick={onCardClick} style={{cursor: "pointer"}}>
      <Card className='case-card-card' >
        <Card.Body className='case-card-body'>
          <span className='case-card-number' >{numberCase}</span>
          <div className='case-card-text-container '>
            <span className='case-card-text'>{caseType}</span>
          </div>
        </Card.Body>
        <div className={`case-card-color-identifier ${bgColorClass}`}></div>
      </Card>
    </div>
  );
}

export default CaseCard;
